import React from "react";
import Row from "./HistoryTableRow";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import { visuallyHidden } from "@mui/utils";

import { TableHead, TableSortLabel, Box } from "@material-ui/core";
import { connect } from "react-redux";
import { useTablesStyle } from "../../../styles/tableStyle";
import no from "../../../img/data-not-found.webp";
import Load from "../../../img/Spin-1s-200px.svg";
import { FindOrdersHistory } from "../../../redux/OrderHistory/historyActions";

import {
  clearSearch,
  searchHistoryOrders,
} from "../../../redux/General/generalActions";
import Store from "../../../redux/Store";
import { findOrdersHistory } from "../../../redux/Orders/OrderActionCreators";

const HistoryTable = ({
  ordersHistory,
  historyReducer,
  searchReducer,
  loading,
}) => {
  const classes = useTablesStyle();
  const { startDate, endDate } = historyReducer;
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("order_date");
  const [current_row, set_current_row] = React.useState("");

  React.useEffect(() => {
    FindOrdersHistory();
  }, [startDate, endDate]);

  React.useEffect(() => {
    return () => {
      clearSearch();
      Store.dispatch(findOrdersHistory([]));
    };
  }, []);

  const orders = searchHistoryOrders(
    ordersHistory.sort((a, b) => {
      return b.order_date > a.order_date;
    }),
    {
      ...searchReducer,
      ...historyReducer,
    }
  ).sort(function (a, b) {
    let val_1 = a[orderBy];
    let val_2 = b[orderBy];
    if (order === "asc" && !isNaN(val_1)) {
      if (val_1 - val_2) return -1;
      return 1;
    } else if (order === "asc" && isNaN(val_1)) {
      if (val_1 > val_2) return 1;
      return -1;
    } else if (order === "desc" && isNaN(val_1)) {
      if (val_1 < val_2) return 1;
      return -1;
    } else {
      if (val_2 - val_1) return 1;
      return -1;
    }
  });

  return (
    <TableContainer
      elevation={0}
      style={{
        maxHeight: "50vh",
        overflow: "auto",
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow className={classes.TableRow} style={{ height: 53 }}>
            {tableHeads.map((item, i) => {
              return (
                <TableCell
                  width={item.width}
                  key={i}
                  className={classes.TableCell}
                  style={{ width: item.width }}
                  sortDirection={orderBy === item.id ? order : false}
                  onClick={() => {
                    setOrderBy(item.id);
                    setOrder(order === "asc" ? "desc" : "asc");
                  }}
                >
                  {item.id !== "code" && item.id !== "state" ? (
                    <TableSortLabel
                      active={orderBy === item.id}
                      direction={orderBy === item.id ? order : "desc"}
                      onClick={() => {
                        setOrderBy(item.id);
                        setOrder(order === "asc" ? "desc" : "asc");
                      }}
                    >
                      {orderBy === item.id ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </Box>
                      ) : null}
                      {item.title}
                    </TableSortLabel>
                  ) : (
                    item.title
                  )}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody style={{ overflow: "hidden" }}>
          <Row
            row={orders}
            set_current_row={set_current_row}
            current_row={current_row}
          />
        </TableBody>
        {orders.length === 0 && !loading ? (
          <ErrorMessage />
        ) : loading ? (
          <LoadingTable />
        ) : null}
      </Table>
    </TableContainer>
  );
};

const mapToStateProps = (props) => {
  const { OrderReducer, historyReducer, loginReducer, searchReducer } = props;
  const { ordersHistory } = OrderReducer;
  const { loading } = loginReducer;
  return { ordersHistory, historyReducer, loading, searchReducer };
};

export default connect(mapToStateProps)(HistoryTable);
const ErrorMessage = () => {
  return (
    <TableBody style={{}}>
      <TableRow style={{ height: 400, border: "none" }}>
        <TableCell
          style={{ width: "100%", textAlign: "center", border: "none" }}
        >
          <img src={no} alt="" width={100} height={100} />
        </TableCell>
      </TableRow>
    </TableBody>
  );
};
const LoadingTable = () => {
  return (
    <TableBody style={{}}>
      <TableRow style={{ height: 400, border: "none" }}>
        <TableCell
          style={{ width: "100%", textAlign: "center", border: "none" }}
        >
          <img src={Load} alt="" />
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

let tableHeads = [
  { title: "شماره سفارش", width: "15%", id: "number" },
  { title: "هزینه کل", width: "10%", id: "price" },
  { title: "تعداد فایل", width: "15%", id: "qtty" },
  { title: "زمان سفارش", width: "15%", id: "order_date" },
  { title: "زمان ارسال", width: "15%", id: "delivery_date" },
  { title: "بارکد", width: "10%", id: "state" },
  { title: "", width: "10%", id: "code" },
];
